import { BuyToneDto } from '../../../../core/dto/buytone/buytonedto';
import { APIModel, APIModelImpl, APIModelHandler } from '../../../toolkit/uicomponentapimodel';
import { BaseContext } from '../../../../utils/basecontext';
import { BuyMusicChannelDtoImpl } from '../../../../core/dto/buymusicchannel/buymusicchanneldto';
import { BuyMusicChannelResponse } from '../../../../core/api/wishlist/buymusicchannel/buymusicchannelresponse';
import { BuyMusicChannelRequestImpl } from '../../../../core/api/wishlist/buymusicchannel/buymusicchannelrequest';
import { AddNameTuneDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/addnametune/addnametunedto';
import { AddNameTuneResponse } from 'src/com/sixdee/crbtportal/core/api/nametune/addnametuneresponse';
import { AddNameTuneRequestImpl } from 'src/com/sixdee/crbtportal/core/api/nametune/addnametunerequest';
import { ReferToneDto } from 'src/com/sixdee/crbtportal/core/dto/refertone/refertonedto';
import { SubscriberValidationDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/subscribervalidation/subscribervalidationdto';
import { SubscriberValidationResponse } from 'src/com/sixdee/crbtportal/core/api/subscribervalidation/subscribervalidationresponse';
import { SubscriberValidationRequestImpl } from 'src/com/sixdee/crbtportal/core/api/subscribervalidation/subscribervalidationrequest';
import { SendOTPDto } from 'src/com/sixdee/crbtportal/core/dto/otp/sendotp/sendotpdto';
import { GetTonePriceDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/gettoneprice/gettonepricedto';
import { GetTonePriceResponse } from 'src/com/sixdee/crbtportal/core/api/tune/gettuneprice/gettonepriceresponse';
import { GetTonePriceRequestImpl } from 'src/com/sixdee/crbtportal/core/api/tune/gettuneprice/gettonepricerequest';
import { GenerateOTPDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/otp/generateotp/generateotpdto';
import { GenerateOTPResponse } from 'src/com/sixdee/crbtportal/core/api/otp/generateotp/generateotpresponse';
import { GenerateOTPRequestImpl } from 'src/com/sixdee/crbtportal/core/api/otp/generateotp/generateotprequest';

export interface BuyNameToneAPIModel extends APIModel 
{
    buyTone(buyToneDto: ReferToneDto): void;
    buyMusicChannelAPI(buyToneDto: BuyToneDto): void;
    getOTP(createAccountOtpDto: SendOTPDto): void;
    validateNumber(giftDto:SendOTPDto):void;
    getTonePrice(toneId: string): void;
    getTonePriceNonLoggedInuser(toneId: string, aPartyMsisdn: string): void;
}

export class BuyNameToneAPIModelImpl extends APIModelImpl implements BuyNameToneAPIModel 
{
    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler) 
    {
        super(applicationContext, apiModelHandler);
    }

    getTonePrice(toneId: string): void 
    {
        let getTonePriceDto =  new GetTonePriceDtoImpl();
        getTonePriceDto.setLanguage(this.getContext().getUserContext().getLanguage());
        getTonePriceDto.setServiceId("1");
        getTonePriceDto.setAPartyMsisdn(this.getContext().getUserContext().getMsisdn());
        getTonePriceDto.setToneId(toneId);
        getTonePriceDto.setValidationIdentifier("3");
        getTonePriceDto.setChannelId(this.getContext().getUserContext().getChannelId());

        this.getAPIProcesssorFactory().getToneProcessorFactory().getGetTonePriceAPIProcessor()
        .success((getTonePriceResponse : GetTonePriceResponse)=>
         {
            this.getAPIModelHandler().onSuccess(getTonePriceResponse.getAPIFeature(), 
            getTonePriceResponse.getDescription(), getTonePriceResponse.getGetTonePriceDto().getToneDetailsList()[0]);
         })
       .failure((getTonePriceResponse : GetTonePriceResponse)=>
       {
           this.getAPIModelHandler().onFailure(getTonePriceResponse.getAPIFeature(), 
           getTonePriceResponse.getDescription(), getTonePriceResponse);
         })
       .execute(new GetTonePriceRequestImpl(getTonePriceDto));
    }

    getTonePriceNonLoggedInuser(toneId: string, aPartyMsisdn: string): void 
    {
        let getTonePriceDto =  new GetTonePriceDtoImpl();
        getTonePriceDto.setLanguage(this.getContext().getUserContext().getLanguage());
        getTonePriceDto.setServiceId("1");
        getTonePriceDto.setAPartyMsisdn(aPartyMsisdn);
        getTonePriceDto.setToneId(toneId);
        getTonePriceDto.setValidationIdentifier("3");
        getTonePriceDto.setChannelId(this.getContext().getUserContext().getChannelId());

        this.getAPIProcesssorFactory().getToneProcessorFactory().getGetTonePriceAPIProcessorNonLoggedInUser()
        .success((getTonePriceResponse : GetTonePriceResponse)=>
         {
            this.getAPIModelHandler().onSuccess(getTonePriceResponse.getAPIFeature(), 
            aPartyMsisdn, getTonePriceResponse.getGetTonePriceDto().getToneDetailsList()[0]);
         })
       .failure((getTonePriceResponse : GetTonePriceResponse)=>
       {
           this.getAPIModelHandler().onFailure(getTonePriceResponse.getAPIFeature(), 
           getTonePriceResponse.getDescription(), getTonePriceResponse);
         })
       .execute(new GetTonePriceRequestImpl(getTonePriceDto));
    }

    validateNumber(giftDto:SendOTPDto):void
    {
      let subscriberValidationDto = new SubscriberValidationDtoImpl();
      subscriberValidationDto.setMsisdn(giftDto.getMsisdn());
      subscriberValidationDto.setLanguage(this.getContext().getUserContext().getLanguage());

      this.getContext().getAPIProcessorFactory().getLoginAPIProcessorFactory().validateSubscriber()
          .success(() => {
              this.getOTP(giftDto);
          })
          .failure((subscriberValidationResponse: SubscriberValidationResponse) => {
              this.getAPIModelHandler().onFailure(subscriberValidationResponse.getAPIFeature(),
                  subscriberValidationResponse.getDescription(), subscriberValidationResponse);
          })
          .execute(new SubscriberValidationRequestImpl(subscriberValidationDto));
    }
    getOTP(createAccountOtpDto: SendOTPDto): void 
    {
      let generateOtp = new GenerateOTPDtoImpl();
      generateOtp.setMsisdn(createAccountOtpDto.getMsisdn());

        this.getContext().getAPIProcessorFactory().getLoginAPIProcessorFactory().generateOTP()
                .success((generateOTPResponse : GenerateOTPResponse)=>
                {
                    this.getAPIModelHandler().onSuccess(generateOTPResponse.getAPIFeature(), 
                    generateOTPResponse.getDescription(), generateOTPResponse);
                })
                .failure((generateOTPResponse : GenerateOTPResponse)=>
                {
                    this.getAPIModelHandler().onFailure(generateOTPResponse.getAPIFeature(), 
                         generateOTPResponse.getDescription(), generateOTPResponse);

                }).execute(new GenerateOTPRequestImpl(generateOtp));
    }
    buyTone(buyToneDto: ReferToneDto): void 
    {
      let addNameTuneDto = new AddNameTuneDtoImpl();
      addNameTuneDto.setChannelId(this.getContext().getUserContext().getChannelId());
      addNameTuneDto.setUserName(this.getContext().getUserContext().getUsername());
      addNameTuneDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
      addNameTuneDto.setToneId(buyToneDto.getToneId());
      addNameTuneDto.setToneName(buyToneDto.getToneName());
      addNameTuneDto.setLanguage(this.getContext().getUserContext().getLanguage());
      addNameTuneDto.setPackName(buyToneDto.getPackName());

      this.getAPIProcesssorFactory().getNameTuneProcessorFactory()
                   .getAddNameTuneAPIProcessor()
                .success((addNameTuneResponse: AddNameTuneResponse)=>
                {
                  console.log("NAMETUNE SUCCESS ######################################################3");
                   this.getAPIModelHandler().onSuccess(addNameTuneResponse.getAPIFeature(), 
                   addNameTuneResponse.getDescription(), addNameTuneResponse);
                })
                .failure((addNameTuneResponse: AddNameTuneResponse)=>
                {
                    this.getAPIModelHandler().onFailure(addNameTuneResponse.getAPIFeature(), 
                    addNameTuneResponse.getDescription(), undefined);
                })
                .execute(new AddNameTuneRequestImpl(addNameTuneDto));
    }

    buyMusicChannelAPI(buyToneDto: BuyToneDto): void 
     { 
             console.log("buyMusicChannelAPI() invoked ##########BUY MUSIC CHANNEL ###############");
             let buyMusicChannelDto = new BuyMusicChannelDtoImpl();
             buyMusicChannelDto.setServiceId("7");
             buyMusicChannelDto.setAPartyMsisdn(this.getContext().getUserContext().getMsisdn());
             buyMusicChannelDto.setToneId(+buyToneDto.getToneId());
             buyMusicChannelDto.setLanguage(this.getContext().getUserContext().getLanguage());
             buyMusicChannelDto.setPriority("0");
             buyMusicChannelDto.setPaymentMode("2");
    
             this.getAPIProcesssorFactory().getToneProcessorFactory()
             .getBuyMusicChannel()
             .success((buyMusicChannelResponse: BuyMusicChannelResponse)=>
             {
                 console.log("getMusicBoxContentsAPI success ###############BUY MUSIC CHANNEL#################");
                 this.getAPIModelHandler().onSuccess(buyMusicChannelResponse.getAPIFeature(), 
                 buyMusicChannelResponse.getDescription(), buyMusicChannelResponse);
              })
             .failure((buyMusicChannelResponse: BuyMusicChannelResponse)=>
              {
                this.getAPIModelHandler().onFailure(buyMusicChannelResponse.getAPIFeature(), 
                buyMusicChannelResponse.getDescription(), undefined);
              })
             .execute(new BuyMusicChannelRequestImpl(buyMusicChannelDto));
     } 
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/nametune/nametuneapimodel.tsx